import { useEffect, useState } from 'react';

export const useDialogFeedback = ({ feedback, generatedGoodFeedback, generatedBadFeedback }) => {
  const showFeedbackGeneratedWithAI = false;
  const [goodFeedback, setGoodFeedback] = useState(feedback.goodFeedback);
  const [badFeedback, setBadFeedback] = useState(feedback.badFeedback);

  useEffect(() => {
    setGoodFeedback(feedback.goodFeedback);
    setBadFeedback(feedback.badFeedback);
  }, [feedback.goodFeedback, feedback.badFeedback]);

  useEffect(() => {
    if (generatedGoodFeedback) {
      setGoodFeedback(generatedGoodFeedback);
    }
    if (generatedBadFeedback) {
      setBadFeedback(generatedBadFeedback);
    }
  }, [generatedGoodFeedback, generatedBadFeedback]);

  function onChangeGoodFeedback(value) {
    setGoodFeedback(value);
  }

  function onChangeBadFeedback(value) {
    setBadFeedback(value);
  }

  return { showFeedbackGeneratedWithAI, goodFeedback, badFeedback, onChangeGoodFeedback, onChangeBadFeedback };
};
